<template>
  <div class="dashboard-form-edit">
    <h2>Edit your form</h2>

    <div class="md-layout md-alignment-top-left">
      <div class="md-layout-item md-small-size-100 md-size-66 ">
          <form-edit-form :current-form="form"></form-edit-form>
      </div>
    </div>
  </div>
</template>

<script>
import FormEditForm from '../forms/FormEditForm'

export default {
  name: 'DashboardFormEdit',
  components: {
    FormEditForm
  },
  computed: {
    form () {
      return this.$store.getters['currentForm']
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/DashboardFormEdit.vue